module.exports = __webpack_public_path__ + "static/media/higher-education-square.559c70db.jpg";